export default "__VITE_ASSET__Caak18ll__"